module.exports = {
  colors: {
    white: 'FFFFFF',
    grey: '#F8F8F8',
    grey2: '#646A6B',
    grey3: '#EBEBEB',
    grey4: 'rgba(34, 42, 43, 0.7)',
    blue: '#2B9FA8',
    black: '#161f26',
    lilac: '#726DE1',

    screenBackground: '#ffffff',
    main: '#726DE1',
    lightMain: '#d4ebee',
    hoverMain: '#aad7dd'
  },
  space: [
    0,
    4,
    8,
    16,
    18,
    20,
    24,
    28,
    30,
    32,
    40,
    50,
    60,
    64,
    120,
    128,
    188,
    200,
    256,
    400,
    512
  ],
  fontSizes: [8, 10, 12, 14, 16, 18, 20, 24, 26, 28, 30, 32, 34, 36],
  fontWeights: {},
  lineHeights: {},
  shadows: {},
  variants: {},
  text: {},
  buttons: {
    main: {
      fontFamily: 'SpaceGrotesk-Bold',
      textAlign: 'center',
      color: '#ffffff',
      borderRadius: '5px',
      boxShadow: '0 1px 7px 0 rgba(0, 0, 0, 0.15)',
      backgroundColor: '#726DE1',
      '&:hover': {
        opacity: '0.5'
      },
      '&:active': {
        backgroundColor: '#726DE1'
      },
      '&:focus': {
        backgroundColor: '#726DE1',
        outline: 'none'
      },
      '&:disabled': {
        backgroundColor: '#dbe2e7',
        cursor: 'not-allowed',
        opacity: '1'
      },
      cursor: 'pointer'
    },
    secondary: {
      fontFamily: 'SpaceGrotesk-Bold',
      fontSize: '20px',
      textAlign: 'center',
      color: '#ffffff',
      width: '90px',
      height: '40px',
      borderRadius: '5px',
      boxShadow: '0 1px 7px 0 rgba(0, 0, 0, 0.15)',
      backgroundColor: '#726DE1',
      '&:hover': {
        opacity: '0.5'
      },
      '&:active': {
        backgroundColor: '#726DE1'
      },
      '&:focus': {
        backgroundColor: '#726DE1',
        outline: 'none'
      },
      '&:disabled': {
        backgroundColor: '#dbe2e7',
        cursor: 'not-allowed',
        opacity: '1'
      },
      cursor: 'pointer'
    },
    link: {
      fontFamily: 'SpaceGrotesk-Bold',
      fontSize: '14px',
      textAlign: 'left',
      backgroundColor: '#FFFFFF',
      color: '#726DE1',
      textDecoration: 'underline',
      height: '40px',
      '&:hover': {
        opacity: '0.5'
      },
      '&:active': {},
      '&:focus': {
        outline: 'none'
      },
      '&:disabled': {
        cursor: 'not-allowed',
        color: '#726DE1',
        opacity: '0.3'
      },
      cursor: 'pointer'
    }
  }
};
